import { useQuery } from '@tanstack/react-query';

import type { PaginatedData, Partner, WelcomeBonusCampaign } from '../@types/api';
import { QUERY_KEYS } from '../constants';
import API_ROUTES from '../constants/apiRoutes';
import { WELCOME_BONUS_SCOPE } from '../constants/enums';
import { USER_ROLES } from '../constants/keycloak';
import { getData } from '../utils/api';

export const useAssignedAffiliateOptions = (
  campaign: Pick<WelcomeBonusCampaign, 'id' | 'affiliateIds' | 'welcomeBonusScope'>
) => {
  const affiliateIds = campaign.affiliateIds ?? [];
  const enabled = campaign.welcomeBonusScope === WELCOME_BONUS_SCOPE.SPECIAL && affiliateIds.length > 0;

  return useQuery<PaginatedData<Partner>>({
    queryKey: [QUERY_KEYS.partners, 'assigned-affiliates', campaign.id, affiliateIds],
    queryFn: () =>
      getData(
        API_ROUTES.AGENT_SEARCH,
        {
          limit: Math.min(affiliateIds.length, 1_000),
          roleTypes: [USER_ROLES.AFFILIATE],
          filters: {
            userId: {
              values: affiliateIds,
              shouldInclude: true,
            },
          },
        },
        'crm'
      ),
    enabled,
  });
};
